const CustomModal = ({
  isOpen,
  onClose,
  title,
  onSubmit,
  showButton,
  showSubmitButton = true,
  showCancelButton = true,
  fontSize = "16px",
  fontWeight = "400",
  children,
  modalSize = "",
  minHeight = "200px",
  maxHeight = "550px",
  /** When set, uses slate-style header/footer and Bootstrap pill buttons */
  variant = "default",
  submitLabel = "Save",
  submitDisabled = false,
}) => {
  if (!isOpen) return null;

  const isModern = variant === "modern";

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(e);
  };

  return (
    <form onSubmit={handleFormSubmit} className="fs-13px">
      <div
        className="modal fade show d-block donezo-modal-backdrop"
        role="dialog"
        aria-modal="true"
        aria-labelledby={isModern ? "custom-modal-title" : undefined}
      >
        <div
          className={`modal-dialog modal-dialog-centered ${modalSize}`.trim()}
        >
          <div
            className={`modal-content ${isModern ? "donezo-custom-modal border-0 shadow-lg overflow-hidden" : ""}`}
            style={{
              borderRadius: isModern ? "16px" : "20px",
              minHeight: minHeight,
              maxHeight: maxHeight,
            }}
          >
            <div
              className={`modal-header ${isModern ? "donezo-custom-modal__header border-0 text-white pb-3 pt-4 px-4" : ""}`}
              style={
                isModern
                  ? undefined
                  : { border: "none", paddingBottom: "0px" }
              }
            >
              <h2
                id="custom-modal-title"
                className={`modal-title mb-0 ${isModern ? "h5 fw-semibold text-white" : ""}`}
                style={
                  isModern
                    ? undefined
                    : { fontSize: fontSize, fontWeight: fontWeight }
                }
              >
                {title}
              </h2>
              <button
                type="button"
                className={`btn-close ${isModern ? "btn-close-white" : ""}`}
                onClick={onClose}
                aria-label="Close"
              />
            </div>
            <div
              className={`modal-body ${isModern ? "donezo-custom-modal__body px-4 pt-2 pb-4" : ""}`}
              style={{
                overflowY: "auto",
              }}
            >
              {children}
            </div>

            {showButton && (
              <div
                className={`modal-footer ${isModern ? "donezo-custom-modal__footer border-0 px-4 pb-4 pt-0 gap-2" : ""}`}
                style={isModern ? undefined : { border: "none" }}
              >
                {showCancelButton &&
                  (isModern ? (
                    <button
                      onClick={onClose}
                      type="button"
                      className="btn donezo-custom-modal__cancel rounded-pill px-4"
                    >
                      Cancel
                    </button>
                  ) : (
                    <button
                      onClick={onClose}
                      type="button"
                      className="btn"
                      style={{ ...buttonStyles.base, ...buttonStyles.cancel }}
                    >
                      Cancel
                    </button>
                  ))}

                {showSubmitButton &&
                  (isModern ? (
                    <button
                      type="submit"
                      className="btn btn-primary donezo-custom-modal__submit rounded-pill px-4 shadow-sm"
                      disabled={submitDisabled}
                    >
                      {submitLabel}
                    </button>
                  ) : (
                    <button
                      onClick={onSubmit}
                      type="button"
                      className="btn"
                      style={{ ...buttonStyles.base }}
                      disabled={submitDisabled}
                    >
                      {submitLabel}
                    </button>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

const buttonStyles = {
  base: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: "600",
    minWidth: "107px",
    width: "auto",
    borderRadius: "10px",
    minHeight: "44px",
    height: "auto",
    padding: "10px 20px",
    border: "none",
    outline: "none",
    fontSize: "14px",
    lineHeight: "1.4",
    whiteSpace: "nowrap",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    backgroundColor: "#41848F",
    color: "white",
  },
  cancel: {
    backgroundColor: "#C4C4C4",
    color: "#000",
  },
};

export default CustomModal;
